import React from 'react';

const FormGroup: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
	return <div className="form-group">{children}</div>;
};

const Label: React.FC<{ span?: string; required?: boolean; children?: React.ReactNode }> = ({
	required,
	span = 6,
	children,
}) => {
	return <label className={`col-xs-${span} control-label ${required ? 'required' : ''}`}>{children}</label>;
};

// const Form: React.FC<{}> = () => {
// 	const a = [
// 		{
// 			value: 'account',
// 			label: {
// 				name: 'API',
// 				col: 6
// 			},
// 			input: {
// 				type: 'text',
// 				props: {
// 					placeholder: 'string'
// 				}
// 			}
// 		}
// 	]

// 	return (

// 	)
// }

export { FormGroup, Label };
